
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/settings",
      function () {
        return require("private-next-pages/docs/settings/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/settings"])
      });
    }
  